"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonSolUtilsConfigSetup = void 0;
var CommonSolUtilsConfig_1 = require("./CommonSolUtilsConfig");
var CommonSolUtilsConfigSetup = /** @class */ (function () {
    function CommonSolUtilsConfigSetup() {
    }
    CommonSolUtilsConfigSetup.register = function (config) {
        config.registerKey(CommonSolUtilsConfig_1.CommonSolUtilsConfig.defaultSolNetwork);
    };
    return CommonSolUtilsConfigSetup;
}());
exports.CommonSolUtilsConfigSetup = CommonSolUtilsConfigSetup;
//# sourceMappingURL=CommonSolUtilsConfigSetup.js.map